import { usePage } from "@inertiajs/react"

import type { FeatureFlags, SharedProps } from "@/types"

export function useFeatureFlag(flag: keyof FeatureFlags): boolean {
  const { features } = usePage<SharedProps>().props
  return features?.[flag] !== false
}
